import J from 'jquery';

export default {

  methods: {

    scrollTop(cb) {
      const JsearchForm = J('.object-search-form_osf');
      let offset = 0;
      if (JsearchForm.length && J(window).width() < 750) {
        offset = JsearchForm.offset().top + JsearchForm.height();
      }
      const options = { duration: 1200 };
      if (typeof cb === 'function') {
        options.complete = cb;
      }
      J('html').animate({ scrollTop: offset }, options);
    },

    timeToDate(time) {
      const d = new Date(time * 1000);
      const year = d.getFullYear();
      let month = d.getMonth() + 1;
      month = month < 10 ? `0${month}` : month;
      let date = d.getDate();
      date = date < 10 ? `0${date}` : date;
      return `${date}.${month}.${year}`;
    },

  },
};



// WEBPACK FOOTER //
// ./src/mixins/Misc.js